/** Offer prices are displayed here; checkout validates the actual Shopify discount. */
export function parseReferencePrice(value) {
  const clean = String(value ?? '').trim().replace(/[\s\u00a0\u202f]/g, '');
  if (!/^\d+(?:[.,]\d{1,2})?$/.test(clean)) return null;
  const [whole, decimal = ''] = clean.replace(',', '.').split('.');
  const cents = Number(whole) * 100 + Number(decimal.padEnd(2, '0'));
  return Number.isSafeInteger(cents) ? cents : null;
}
export function saving(reference, payable) {
  return Number.isSafeInteger(reference) && reference > payable ? reference - payable : 0;
}
export function readOffer(card, quantity = 1, variant = null) {
  const d = card.dataset;
  const number = (value) => Number.isSafeInteger(Number(value)) ? Number(value) : 0;
  const configuredPrice = number(d.prix);
  const selectedPrice = Number.isSafeInteger(Number(variant?.price)) && Number(variant.price) >= 0 ? Number(variant.price) : configuredPrice;
  const regularPrice = variant ? selectedPrice : (number(d.regularPrice) || configuredPrice);
  const comparePrice = number(d.reference);
  const calculatedSaving = saving(comparePrice, selectedPrice);
  const bundleNative = d.offerKind === 'france' && d.bundleNative === 'true';
  // The included Cat-Mat has its own crossed-out value. Offer savings always describe the
  // difference between the reference price and the payable CatLang price.
  return Object.freeze({
    offerId:d.offerKind || 'essential', bundleNative, key:d.offerKey, variantId:variant?.id ? String(variant.id) : String(d.variantId),
    productId:d.productId, label:d.nom, unitPrice:selectedPrice, regularPrice, priceText:selectedPrice === configuredPrice ? d.prixTexte : formatMoney(selectedPrice),
    comparePrice, compareText:d.referenceText,
    savings:calculatedSaving, savingsText:calculatedSaving === number(d.savings) ? d.savingsText : formatMoney(calculatedSaving), savingsLabel:d.savingsLabel,
    showCompare:d.showCompare==='true', showSavings:d.showSavings==='true',
    image:d.image, imageSrcset:d.imageSrcset, imageAlt:d.imageAlt, giftVariantId:d.giftId,
    giftReferencePrice:number(d.giftPrice), available:(variant ? variant.available !== false : d.available==='true') && (d.offerKind!=='france' || bundleNative || d.giftAvailable!=='false'),
    quantity, selectedVariantId:variant?.id ? String(variant.id) : String(d.variantId)
  });
}
function formatMoney(cents) {
  return new Intl.NumberFormat(globalThis.document?.documentElement?.lang || 'fr-FR', {
    style:'currency',currency:globalThis.window?.Shopify?.currency?.active || 'EUR'
  }).format(cents/100);
}
function moneyNode(tag, className, text) {
  const node=document.createElement(tag);node.className=className;node.textContent=text;return node;
}
if (typeof customElements !== 'undefined' && !customElements.get('catharsis-packs')) {
  class CatharsisPacks extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();this.controller=new AbortController();
      queueMicrotask(() => {if(this.isConnected)this.initialize();});
    }
    disconnectedCallback() {this.controller?.abort();}
    initialize() {
      const {signal}=this.controller;
      this.section=this.closest('[data-product-section]');
      if(!this.section)return;
      this.form=this.closest('form');
      this.cards=[...this.querySelectorAll('[data-packs-palier]')];
      const enabled=this.cards.filter(c=>c.dataset.available==='true');
      const initial=enabled.find(c=>c.dataset.offerKind===this.dataset.defaultOffer)||enabled[0]||this.cards[0];
      this.cards.forEach(c=>{const radio=c.querySelector('[data-packs-radio]');if(radio)radio.checked=c===initial;});
      this.addEventListener('change',e=>{if(e.target.matches('[data-packs-radio]'))this.apply();},{signal});
      this.form?.addEventListener('input',e=>{if(e.target.name==='quantity')this.apply();},{signal});
      this.form?.addEventListener('change',e=>{if(e.target.name==='quantity')this.apply();},{signal});
      this.section.addEventListener('catharsis:variant-change',e=>{
        const next=e.detail||{};
        if(!next.id)return;
        this.variant={
          id:String(next.id),
          available:next.available!==false,
          ...(Number.isSafeInteger(Number(next.price))&&Number(next.price)>=0?{price:Number(next.price)}:{})
        };
        this.apply();
      },{signal});
      document.addEventListener('shopify:block:select',e=>{
        const card=e.target.closest?.('[data-packs-palier]');
        if(card&&this.contains(card)){card.querySelector('[data-packs-radio]').checked=true;this.apply();}
      },{signal});
      this.apply();
    }
    apply() {
      const card=this.querySelector('[data-packs-radio]:checked')?.closest('[data-packs-palier]');
      if(!card)return;
      const quantity=Number(this.form?.querySelector('[name="quantity"]')?.value||1);
      const state=readOffer(card,Number.isInteger(quantity)&&quantity>0?quantity:1,card.dataset.productId===this.dataset.productId?this.variant:null);
      // `variantId` is the cart contract.  Keep the configured offer image and benefits, but
      // use the product picker's validated variant for every future transaction.
      const currentState=Object.freeze({...state,variantId:state.selectedVariantId});
      this.state=currentState;this.section.catharsisOffer=currentState;
      const express=this.section.querySelector('[data-dynamic-checkout-slot]');
      if(express){
        if(this.expressVisibility?.element!==express){
          this.expressVisibility={
            element:express,hidden:express.hidden,
            display:express.style.getPropertyValue('display'),
            priority:express.style.getPropertyPriority('display')
          };
        }
        if(state.offerId==='france'){
          express.hidden=true;
          express.style.setProperty('display','none');
        }else{
          express.hidden=this.expressVisibility.hidden;
          if(this.expressVisibility.display)express.style.setProperty('display',this.expressVisibility.display,this.expressVisibility.priority);
          else express.style.removeProperty('display');
        }
      }
      this.cards.forEach(c=>{c.classList.toggle('c-pack--retenu',c===card);c.dataset.retenu=String(c===card);});
      const id=this.form?.querySelector('[data-variant-id]');if(id)id.value=state.variantId;
      const plan=this.form?.querySelector('[data-selling-plan-input]');
      if(plan&&state.productId!==this.dataset.productId)plan.value='';
      this.section.querySelectorAll('.product-buy__add-price').forEach(node=>{
        node.textContent=(node.textContent.match(/^[^\d]*/)?.[0]||'')+state.priceText;
      });
      this.section.querySelectorAll('[data-price-target]').forEach(target=>{
        const root=target.querySelector('.price')||target;
        const amount=root.querySelector('.price__amount');
        if(amount)amount.textContent=state.priceText;
        let reference=root.querySelector('.price__compare');
        const show=state.showCompare&&state.comparePrice>state.unitPrice;
        if(show&&!reference){reference=moneyNode('s','price__compare',state.compareText);root.append(reference);}
        if(reference){reference.textContent=state.compareText;reference.hidden=!show;}
        root.classList.toggle('price--sale',show);
      });
      this.section.querySelectorAll('[data-price-target] [data-savings]').forEach(node=>{
        node.textContent=`${state.savingsLabel||'Économisez'} ${state.savingsText}`;
        node.hidden=!(state.showSavings&&state.savings>0);
      });
      this.section.querySelectorAll('[data-sticky-price]').forEach(node=>{
        const children=[];
        if(state.showCompare&&state.comparePrice>state.unitPrice)children.push(moneyNode('s','product-sticky-atc__compare',state.compareText));
        children.push(moneyNode('span','product-sticky-atc__amount',state.priceText));
        node.replaceChildren(...children);
      });
      const title=this.section.querySelector('.product-sticky-atc__title');if(title)title.textContent=state.label;
      const image=this.section.querySelector('.product-sticky-atc__img');
      if(image){
        image.hidden=!state.image;
        if(state.image){
          image.src=state.image;
          if(state.imageSrcset) image.srcset=state.imageSrcset;
          else image.removeAttribute('srcset');
          image.alt=state.imageAlt||state.label;
        }
      }
      const selection=this.section.querySelector('[data-sticky-selection]');if(selection)selection.hidden=true;
      this.section.querySelectorAll('[data-add-to-cart],[data-buy-now],[data-sticky-add]').forEach(button=>{
        button.disabled=!state.available||!!this.form?.catharsisBusy;
        button.setAttribute('aria-disabled',String(button.disabled));
      });
      const chosen=this.querySelector('[data-packs-choix-valeur]');if(chosen){chosen.textContent=`${state.label} · ${state.priceText}`;chosen.parentElement.hidden=false;}
      const total=this.querySelector('[data-packs-total-valeur]');if(total){
        const cents=[...card.querySelectorAll('[data-valeur]')].reduce((sum,p)=>sum+Number(p.dataset.valeur||0),0);
        total.textContent=formatMoney(cents);total.parentElement.hidden=cents<=0;
      }
      const event=new CustomEvent('catharsis:offer-change',{bubbles:true,detail:currentState});
      this.section.dispatchEvent(event);
    }
  }
  customElements.define('catharsis-packs',CatharsisPacks);
}
